<template>
  <div class="content">
    <div class="box">
      <p class="chinese-name">联系我们</p>
      <p class="english-name">CONTACT US</p>
      <div class="content-item">
        <div
          class="item-content"
          v-for="item in LIST"
          :key="item.name"
        >
          <div class="item-box">
            <p class="item-title">{{ item.name }}</p>
            <div style="display: flex;">
              <div class="item-left">
                <p>联系电话:</p>
                <p>服务事项:</p>
              </div>
              <div class="item-right">
                <p>{{ item.phone }}</p>
                <p style="padding-bottom: 20px">{{ item.service }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const LIST = [
  { name: '签证服务部', phone: '0591-87810788、0591-87811482', service: '代办我省（除厦漳泉外）公民因私赴日商务考察、探亲访友、居留 等签证' },
  { name: '领事认证服务部', phone: '0591-87815074、0591-87829733', service: '代办领事认证业务' },
  { name: '国际会议接待培训部', phone: '0591-87827158、0591-87804101', service: '组织、策划、承办各类国际国内大中型会议等活动，提供同传翻译 设备和多语种同传、交传翻译服务，负责国（境）外团组接待、培 训业务' },
  { name: '外企人力资源部', phone: '0591-87808128、0591-87813693', service: '为外商常驻代表机构招聘、派遣中方员工，为企业员工代缴“五险 一金”，开展劳务派遣、人事委托等服务' },
  { name: '航空商旅部', phone: '0591-87856791 机票：0591-87828574、0591-87839544', service: '为我省出国团组提供境外接待服务；代办因私签证（除日本国外）； 为公务出访团组代填签证表格和代办境外保险；申办APEC商务旅行 卡；从事机票代理销售等。' },
  { name: '翻译留学部', phone: '0591-87829628、0591-87873331', service: '提供涉外文书翻译和留学、移民咨询服务' }
]
export default {
  name: "contact-box",
  data () {
    return {
      LIST,
    }
  }
}
</script>

<style scoped lang='less'>
.content {
  width: 100%;
  position: relative;
}
.box {
  width: 1266px;
  /* height: 727px; */
  position: relative;
  margin: auto;
  // left: 50%;
  // transform: translateX(-50%);
  background:#FFF;
  padding-top: 100px;
}
.chinese-name {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  position: absolute;
  z-index: 1;
  left: 50%;
  transform: translateX(-50%);
  top: 84px;
}
.english-name {
  // width: 100%;
  font-size: 80px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FAF5F5;
  position: absolute;
  // z-index: -1;
  left: 50%;
  transform: translateX(-50%);
  top: 44px;
}
.desc-title {
  margin-top: 25px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  text-align: left;
}
</style>
<style scoped lang='less'>
.content-item{
  margin: 58px 0 38px;
  background-image: url("../../../assets/images/bg-world-map.png");
  background-size: 100% 100%;
  .item-content {
    width: 555px;
    min-height: 170px;
    height: auto;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    display: inline-block;
    margin: 0 15px 20px 15px;
    padding-bottom: 53px;
    .item-box{
      text-align: left;
      margin-top: 32px;
      margin-left: 40px;
      .item-title{
        height: 18px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #3A3A3A;
        line-height: 28px;
      }
      .item-left{
        width: 65px;
        height: 40px;
        margin-right: 3px;
      }
      .item-right{
        width: 415px;
        height: 61px;
      }
      .item-left,.item-right{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #7F7F7F;
        display: inline-block;
        vertical-align:middle;
      }
    }

  }
  .item-content:hover{
    border: 1px solid #CDAD7F;
    box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/contactUs/siderContent01.vue